export const polling = async <T>({
  fn,
  validate,
  interval = 1000,
  maxAttempts = 10,
}: {
  fn: () => Promise<T>
  validate: (result: T) => boolean
  interval?: number
  maxAttempts?: number
}): Promise<T> => {
  let attempts = 0

  const executePolling = async (): Promise<T> => {
    const result = await fn()

    attempts++

    if (validate(result)) {
      return result
    }
    if (attempts === maxAttempts) {
      throw new Error('Exceeded maximum polling attempts')
    }

    return new Promise<T>((resolve) => {
      setTimeout(() => {
        resolve(executePolling())
      }, interval)
    })
  }

  return executePolling()
}
